import React from "react";
import PropTypes from "prop-types";
import DrugPriceListItem from "./drug-price-list-item";

const DrugPriceList = ({
  drugPrices,
  activeItem,
  selectedItem,
  onItemMouseEnter,
  onItemMouseLeave,
  onItemClick,
  components,
  addToFavorite,
  favoriteList
}) => (
  <div className='price-prescriptions-list-web-sdk'>
    {drugPrices.map(drugPrice => (
      <DrugPriceListItem
        key={drugPrice.PharmacyId}
        drugPrice={drugPrice}
        active={drugPrice.PharmacyId === activeItem}
        selected={drugPrice.PharmacyId === selectedItem}
        onMouseEnter={onItemMouseEnter}
        onMouseLeave={onItemMouseLeave}
        onClick={onItemClick}
        components={components}
        addToFavorite={addToFavorite}
        favoriteList={favoriteList}
      />
    ))}
  </div>
);

export default DrugPriceList;

DrugPriceList.propTypes = {
  drugPrices: PropTypes.array,
  activeItem: PropTypes.any,
  selectedItem: PropTypes.any,
  onItemMouseEnter: PropTypes.func,
  onItemMouseLeave: PropTypes.func,
  onItemClick: PropTypes.func,
  components: PropTypes.any,
  addToFavorite: PropTypes.func,
  favoriteList: PropTypes.arrayOf(PropTypes.string)
};
